<template>
    <div class="container">
        <div class="container-header">
            <div class="search">
                <div class="search-form">
                    <div class="form-item">
                        <span class="form-item-lable">{{ $t('advertBookName') }}</span>
                        <el-input size="mini"
                                  v-model="search.name"
                                  :placeholder="$t('pleaseInputHint')"
                                  clearable
                                  @change="searchHandle"></el-input>
                    </div>
                    <div class="form-item">
                        <span class="form-item-lable">{{ $t('merchant') }}</span>
                        <el-select v-model="search.merchantId"
                                   size="mini"
                                   filterable
                                   clearable
                                   @change="searchHandle">
                            <el-option v-for="item in merchantOptions"
                                       :key="item.id"
                                       :label="item.name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="form-item">
                        <span class="form-item-lable">{{ $t('startTime') }}</span>
                        <el-date-picker size="mini"
                                        v-model="search.startDate"
                                        type="date"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                                        :placeholder="$t('pleaseSelectHint')"
                                        clearable
                                        @change="searchHandle">
                        </el-date-picker>
                    </div>
                    <div class="form-item">
                        <span class="form-item-lable">{{ $t('endTime') }}</span>
                        <el-date-picker size="mini"
                                        v-model="search.endDate"
                                        type="date"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                                        :placeholder="$t('pleaseSelectHint')"
                                        clearable
                                        @change="searchHandle">
                        </el-date-picker>
                    </div>
                    <div class="form-item">
                        <span class="form-item-lable">{{ $t('state') }}</span>
                        <el-select v-model="search.status"
                                   size="mini"
                                   clearable
                                   @change="searchHandle">
                            <el-option v-for="item in statusOptions"
                                       :key="item.value"
                                       :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="search-handle">
                    <div class="handle-left">
                        <el-button type="primary"
                                   size="mini"
                                   @click="searchHandle">{{ $t('search') }}</el-button>
                        <el-button type="primary"
                                   size="mini"
                                   @click="emptyHandle">{{ $t('empty') }}</el-button>
                        <el-button type="primary"
                                   size="mini"
                                   @click="addDialog = true"
                                   v-permission="['adve:book-create']">{{ $t('add') }}</el-button>
                    </div>
                    <div class="handle-right">
                        <el-button type="primary"
                                   size="mini"
                                   @click="issueHandle">{{ $t('onkeyIssue') }}</el-button>
                    </div>
                    
                </div>
            </div>
        </div>
        <div class="container-main">
            <el-table :data="tableData"
                      border
                      style="width: 100%">
                <el-table-column type="index"
                                 align="center"
                                 width="60"></el-table-column>
                <el-table-column :label="$t('advertBookInfo')"
                                 min-width="260">
                    <template slot-scope="scope">
                        <div class="info">
                            <el-image :src="scope.row.cover + '_-100.png'" v-if="scope.row.cover && (scope.row.cover.includes('img.saonian.org') || scope.row.cover.includes('img.joyingo.com'))">
                                <div slot="error"
                                     class="image-slot">
                                    <img src="../../assets/images/default.png"
                                         alt="">
                                </div>
                            </el-image>
                            <el-image :src="scope.row.cover" lazy v-else>
                                <div slot="error"
                                     class="image-slot">
                                    <img src="../../assets/images/default.png"
                                         alt="">
                                </div>
                            </el-image>
                            <div class="desc avatar-desc">
                                <p class="desc-item">{{ scope.row.name }}</p>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="startedAt"
                                 align="center"
                                 :label="$t('merchantName')"
                                 width="150"
                                 show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.merchant">{{ scope.row.merchant.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="startedAt"
                                 align="center"
                                 :label="$t('startTime')"
                                 width="120"
                                 show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.startedAt | formatDate('yyyy-mm-dd') }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="endedAt"
                                 align="center"
                                 :label="$t('endTime')"
                                 width="120">
                    <template slot-scope="scope">
                        <span>{{ scope.row.endedAt | formatDate('yyyy-mm-dd') }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status"
                                 align="center"
                                 :label="$t('state')"
                                 width="120">
                    <template slot-scope="scope">
                        <span class="red"
                              v-if="scope.row.status === 101">{{ $t('advertPaperLack') }}</span>
                        <span class="red"
                              v-else-if="scope.row.status === 102">{{ $t('slicingLack') }}</span>
                        <span v-else-if="scope.row.status === 103">{{ $t('normal') }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="enabled"
                                 align="center"
                                 :label="$t('whetherEnable')"
                                 width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.enabled">{{ $t('yes') }}</span>
                        <span v-else>{{ $t('no') }}</span>
                    </template>
                </el-table-column>
                <el-table-column class-name="handle"
                                 :label="$t('handle')"
                                 align="center"
                                 fixed="right"
                                 width="220">
                    <template slot-scope="scope">
                        <el-button type="text"
                                   size="mini"
                                   @click="paperHandle(scope.row.id)"
                                   v-permission="['adve:paper']">{{ $t('advertPaper') }}
                        </el-button>
                        <el-button type="text"
                                   size="mini"
                                   @click="skipPaperHandle(scope.row.id)"
                                   v-permission="['adve:paper']">{{ $t('details') }}
                        </el-button>
                        <el-button type="text"
                                   size="mini"
                                   @click="editHandle(scope.row.id)"
                                   v-permission="['adve:book-update']">{{ $t('edit') }}
                        </el-button>
                        <el-button type="text"
                                   size="mini"
                                   @click="enableHandle(scope.row.id)"
                                   v-if="!scope.row.enabled && scope.row.status === 103"
                                   v-permission="['adve:book-update']">{{ $t('enable') }}
                        </el-button>
                        <el-button type="text"
                                   size="mini"
                                   class="red"
                                   @click="disenableHandle(scope.row.id)"
                                   v-if="scope.row.enabled"
                                   v-permission="['adve:book-update']">{{ $t('disenable') }}
                        </el-button>
                        <el-button class="red"
                                   type="text"
                                   size="mini"
                                   @click="deleteHandle(scope.row.id)"
                                   v-permission="['adve:book-delete']">{{ $t('delete') }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background
                           :current-page="currentPage"
                           layout="sizes, prev, pager, next, total"
                           :page-sizes="[10, 15, 20, 50, 100]"
                           :page-size="pageSize"
                           :total="total"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange">
            </el-pagination>
        </div>
        <!-- 添加 -->
        <Add :parent-dialog="addDialog"
             @parent-update="getListData"
             @parent-close="addDialog = false" />
        <!-- 编辑 -->
        <Edit :parent-dialog="editDialog"
              :parent-id="itemId"
              @parent-update="getListData"
              @parent-close="editDialog = false" />
        <!-- 广告册 -->
        <Paper :parent-dialog="paperDialog"
               :parent-id="itemId"
               @parent-close="paperDialog = false" />
    </div>
</template>

<script>
import {
    queryAdvertBookList,
    deleteAdvertBook,
    enableAdvertBook,
    disenableAdvertBook,
    searchMerchantList,
    onkeyIssueAdvertBook
} from "@/api/modules/api";
import Add from '@/components/advert/book/Add'
import Edit from '@/components/advert/book/Edit'
// 广告纸
import Paper from '@/components/advert/book/Paper'
export default {
    name: "AdvertBook",
    // 组件
    components: {
        Add,
        Edit,
        Paper
    },
    props: {},
    data () {
        return {
            search: {
                name: '',
                merchantId: '',
                startDate: '',
                endDate: '',
                status: ''
            },
            merchantOptions: [],
            statusOptions: [
                {
                    label: this.$t('advertPaperLack'),
                    value: 101
                },
                {
                    label: this.$t('slicingLack'),
                    value: 102
                },
                {
                    label: this.$t('normal'),
                    value: 103
                }
            ],
            tableData: [],
            currentPage: 1,
            total: 0,
            pageSize: 10,
            addDialog: false,
            itemId: '',
            editDialog: false,
            paperDialog: false
        };
    },
    // 计算属性
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        // 获取商家列表
        getMerchantOptions () {
            const params = {
                name: ''
            }
            searchMerchantList(params).then(res => {
                if (Number(res.code) === 20000) {
                    this.merchantOptions = res.data || []
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
        // 获取数据列表
        getListData () {
            let startedAt = ''
            if (this.search.startDate) {
                let startTime = this.search.startDate + ' 00:00:00'
                startedAt = this.$moment(startTime).format('YYYY-MM-DDTHH:mm:ssZZ')
            }
            let endedAt = ''
            if (this.search.endDate) {
                let endTime = this.search.endDate + ' 00:00:00'
                endedAt = this.$moment(endTime).format('YYYY-MM-DDTHH:mm:ssZZ')
            }
            const params = {
                name: this.search.name.trim(),
                merchantId: this.search.merchantId,
                startedAt,
                endedAt,
                status: this.search.status,
                page: this.currentPage,
                size: this.pageSize
            }
            queryAdvertBookList(params).then(res => {
                if (Number(res.code) === 20000) {
                    this.tableData = res.data.list
                    this.total = res.data.total
                    // 检验是否列表为空
                    if (this.tableData.length === 0 && this.currentPage > 1) {
                        this.currentPage--
                        this.getListData()
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
        // 搜索
        searchHandle () {
            // 当前页码初始化
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        },
        // 清空
        emptyHandle () {
            this.search = {
                name: '',
                merchantId: '',
                startDate: '',
                endDate: '',
                status: ''
            }
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        },
        // 切换页码
        handleCurrentChange (page) {
            // 设置页码
            this.currentPage = page
            // 获取列表数据
            this.getListData()
        },
        // 切换显示条数
        handleSizeChange (size) {
            // 设置大小
            this.pageSize = size
            // 初始化页码
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        },
        // 编辑
        editHandle (id) {
            this.itemId = id
            this.editDialog = true
        },
        // 启用
        enableHandle (id) {
            this.$confirm(this.$t('enableBookHint'), this.$t('hint'), {
                confirmButtonText: this.$t('confirm'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning'
            }).then(() => {
                enableAdvertBook(id).then(res => {
                    if (Number(res.code) === 20000) {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'success'
                        })
                        this.getListData()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message.error(err)
                })
            }).catch(() => { })
        },
        // 禁用
        disenableHandle (id) {
            this.$confirm(this.$t('disenableBookHint'), this.$t('hint'), {
                confirmButtonText: this.$t('confirm'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning'
            }).then(() => {
                disenableAdvertBook(id).then(res => {
                    if (Number(res.code) === 20000) {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'success'
                        })
                        this.getListData()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message.error(err)
                })
            }).catch(() => { })
        },
        // 删除
        deleteHandle (id) {
            this.$confirm(this.$t('deleteItemHint'), this.$t('hint'), {
                confirmButtonText: this.$t('confirm'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning'
            }).then(() => {
                deleteAdvertBook(id).then(res => {
                    if (Number(res.code) === 20000) {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'success'
                        })
                        this.getListData()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message.error(err)
                })
            }).catch(() => { })
        },
        // 广告纸
        paperHandle (id) {
            this.itemId = id
            this.paperDialog = true
        },
        // 详情
        skipPaperHandle (id) {
            this.$router.push({
                name: 'AdvertPaper',
                query: {
                    id: id
                }
            })
        },
        // 一键发布
        issueHandle () {
            this.$confirm(this.$t('onkeyIssueHint'), this.$t('hint'), {
                confirmButtonText: this.$t('confirm'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning'
            }).then(() => {
                onkeyIssueAdvertBook().then(res => {
                    if (Number(res.code) === 20000) {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'success'
                        })
                        this.getListData()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message.error(err)
                })
            }).catch(() => { })
        },
    },
    // 创建完成
    created () {
    },
    // 挂载完成
    mounted () {
        // 获取商家列表
        this.getMerchantOptions()
    },
    beforeRouteEnter(to, from, next) {
        next((vm)=>{
            if (to.name === 'AdvertBook' && from.name !== 'AdvertPaper') {
                // 获取列表数据
                vm.emptyHandle()
            } else if (to.name === 'AdvertBook' && vm.tableData.length === 0){
                // 获取列表数据
                vm.emptyHandle()
            }
        })
    },
    // 销毁之前
    beforeDestroy () {
    }
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/base-column.scss';
.container-header{
    .search-handle{
        width: 100%;
        display: flex;
        justify-content: space-between;
    }
}
</style>
